module.exports = __webpack_public_path__ + "img/neteller_select.7aba3165.png";